import { type HTMLMotionProps, motion } from 'framer-motion';
import React, { forwardRef } from 'react';
import { EdgeDropIndicator } from './DropIndicator';
import {
  DRAG_OPACITY_DIM,
  DRAG_SCALE_DOWN,
  SHELL_SPRING,
} from './animationConfig';

interface DraggableItemShellProps extends HTMLMotionProps<'div'> {
  isDragging: boolean;
  children: React.ReactNode;
  dropAbove?: boolean;
  dropBelow?: boolean;
}

export const DraggableItemShell = forwardRef<
  HTMLDivElement,
  DraggableItemShellProps
>(({ isDragging, dropAbove, dropBelow, children, style, ...rest }, ref) => (
  <>
    <EdgeDropIndicator edge={dropAbove ? 'top' : null} />
    <motion.div
      ref={ref}
      animate={{
        opacity: isDragging ? DRAG_OPACITY_DIM : 1,
        scale: isDragging ? DRAG_SCALE_DOWN : 1,
      }}
      transition={SHELL_SPRING}
      style={{
        transformOrigin: 'left center',
        willChange: 'transform, opacity',
        ...style,
      }}
      {...rest}
    >
      {children}
    </motion.div>
    <EdgeDropIndicator edge={dropBelow ? 'bottom' : null} />
  </>
));

DraggableItemShell.displayName = 'DraggableItemShell';
